<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-12">
        <h3
          class="mb-0"
          v-html="$t('lang.transfer.transfers_in', {city: cityName.toUpperCase()})"
        />
        <div
          v-if="city.isRideType"
          class="poweredBy mb-3"
        >
          <span class="small">Powered by
            <img
              src="../../assets/img//transfers/cabify-logo.png"
              height="15"
            >
          </span>
        </div>
        <div class="row">
          <div class="col-12">
            <Errors :errors="errors" />
            <p
              class="alert alert-success"
              v-html="$t('lang.transfer.discount_alert')"
            />
            <!-- REVIEWS  -->
            <div
              v-if="zoneDetails.general_data"
              class="col-12 p-0 pt-2 mb-3"
            >
              <CityInfo :info="zoneDetails" />
            </div>
            <!-- ORIGIN & DESTINATION  -->
            <OriginAndDestination
              v-if="zones"
              :is-ride-type="city.isRideType"
              :zones="zones"
              :default-zones="defaultZones"
              @zonesSelected="searchVehicles"
            />
            <!-- CARS RESULTS  -->
            <div
              v-if="showCars"
              class="mt-3"
            >
              <div class="d-flex mb-2 align-items-center h-auto">
                <i
                  class="pe-7s-car color_text pl-1"
                  style="font-size: 2rem; font-weight: bold"
                />
                <h4 class="m-0 p-0 pl-2 w-auto h-auto">
                  {{ $t('lang.transfer.vehicles') }}
                </h4>
              </div>

              <div
                v-for="car in cars"
                :key="car.label"
                class="strip list_view mb-4"
              >
                <!-- CAR CARD -->
                <CarCard
                  :car="car"
                  @carSelected="carSelected"
                  @rideSelected="rideSelected"
                />
              </div>

              <p class="text-right float-right mt-n3 color-gray">
                {{ $t('lang.transfer.images') }}
              </p>
            </div>

            <!-- BOOKING DATA  -->
            <div
              v-if="showBookingData"
              class="mt-5"
            >
              <div class="d-flex mb-2 align-items-end">
                <i
                  class="pe-7s-car color_text pl-1"
                  style="font-size: 2rem; font-weight: bold"
                />
                <h4
                  id="booking-data"
                  class="m-0 p-0 pl-2 w-auto h-auto"
                >
                  {{ $t('lang.transfer.booking_title') }}
                </h4>
              </div>
              <div class="strip list_view mb-4">
                <!-- CAR CARD -->
                <CarCard
                  :car="selectedCar"
                  :selected-car-option="true"
                />
                <!-- BOOKING DATA -->
                <TransferBookingData
                  :ask-for="bookingDataNeeded"
                  :required-data="requiredDataForCheckout"
                  :errors="bookErrors"
                  :selected-car="selectedCar"
                  :user="user"
                  @updatedDateAndPax="addToCart"
                  @updatedCheckoutData="sendCheckoutData"
                />
              </div>

              <b-link @click="backToCars()">
                <i class=" icon-left-big" />{{ $t('lang.forms.back') }}
              </b-link>
            </div>

            <!-- PAYMENT  -->
            <div
              v-if="showPayment"
              class="mt-3"
            >
              <div class="d-flex mb-2 align-items-center h-auto">
                <i
                  class="pe-7s-car color_text pl-1"
                  style="font-size: 2rem; font-weight: bold"
                />
                <h4 class="m-0 p-0 pl-2 w-auto h-auto">
                  {{ $t('lang.transfer.payment_title') }}
                </h4>
              </div>

              <div class="strip list_view mb-4">
                <!-- CAR CARD -->
                <CarCard
                  :car="selectedCar"
                  :selected-car-option="true"
                />
                <div class="row pt-0 pr-4 pl-4 pb-4 justify-content-center">
                  <div class="col-12 col-lg-8 mb-4">
                    <StripeCheckout
                      v-if="paymentData.payment_preference_id"
                      :payment-preference-id="paymentData.payment_preference_id"
                      :return-url="returnUrl"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showImage"
      class="row justify-content-center"
    >
      <div class="col-12 col-lg-6 text-center">
        <img
          width="80%"
          src="../../assets/img/transfers/transfers-illustration.png"
        >
      </div>
      <div
        v-if="zoneDetails.faqs"
        class="col-12 mt-5"
      >
        <FAQs :info="zoneDetails.faqs" />
      </div>
    </div>
  </div>
</template>

<script>

import Errors from '@/components/Alerts/Errors';

import CityInfo from '@/components/Transfer/CityInfo';
import OriginAndDestination from '@/components/Transfer/OriginAndDestination';
import CarCard from '@/components/Transfer/CarCard';
import TransferBookingData from '@/components/Transfer/TransferBookingData';
import StripeCheckout from '@/components/Payments/StripeCheckout';
import FAQs from '@/components/Transfer/FAQs';
import { API, errorResponse } from '../../api/api';
import { formatDateIsoLike } from '@/utils/dateFormatters';

const TransferAPI = API.get('transfer');

export default {
  name: 'TransferForm',
  components: {
    FAQs,
    StripeCheckout,
    TransferBookingData,
    CarCard,
    OriginAndDestination,
    CityInfo,
    Errors,
  },
  props: {
    city: {
      type: Object,
      required: true,
    },
    storeId: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      zones: null,
      cars: [],
      zoneDetails: {},
      transfer: {},
      requiredDataForCheckout: null,
      user: {},
      checkoutData: [],
      paymentData: {},
      returnUrl: null,

      origin: null,
      destination: null,
      selectedCar: {},

      errors: {},
      bookErrors: {},
      showCars: false,
      showBookingData: false,
      bookingDataNeeded: null,
      showPayment: false,
      showImage: true,
      defaultZones: null,
      rideSchedule: null,
    };
  },
  computed: {
    cityName() {
      return this.$t(`lang.cities.${this.city.id}`);
    },
  },

  async created() {
    if (this.storeId) {
      this.storeId = this.$route.query.store_id;
      await Promise.all([this.getVehiclesByStoreId(), this.getZones()]);
    } else {
      await this.getZones();
    }
    if (!this.city.isRideType) {
      const info = await TransferAPI.getCityInfo(this.city.bd_city_id);
      this.zoneDetails = info.data;
    }
  },
  methods: {

    async getZones() {
      try {
        const { data } = await TransferAPI.getZones(this.city.bd_city_id);
        // filter zones that have a null label. Civitatis error.
        const filteredZones = data.zones.filter((zone) => zone.label !== null && zone.label !== '');
        this.zones = filteredZones.sort((a, b) => a.label.localeCompare(b.label));
      } catch (error) {
        this.errors = errorResponse(error);
        if (error.response.status === 401) {
          await this.$store.dispatch('setAuthToShow', 'login');
          this.$root.$emit('bv::show::modal', 'authModal');
          // GTAG Event
          dataLayer.push({
            event: 'open_auth_modal',
            source: 'transfers',
          });
        }
      }
    },
    async getVehiclesByStoreId() {
      try {
        const payload = {
          store_id: this.storeId,
          currency: this.$store.state.main.currency,
        };

        const { data } = await TransferAPI.getVehiclesByStoreId(payload);

        this.cars = data.vehicles.sort((a, b) => parseFloat(a.total_price) - parseFloat(b.total_price));
        this.defaultZones = data.zones;

        this.showCars = true;
        this.showImage = false;
        this.origin = data.zones.zone_from;
        this.destination = data.zones.zone_to;
      } catch (error) {
        // nada, que muestre las zonas normalmente
      }
    },

    async searchVehicles(start, end, date = 0) {
      if (start && end) {
        this.origin = start;
        this.destination = end;
        const payload = {
          city_id: this.city.bd_city_id,
          zone_from: start,
          zone_to: end,
          currency: this.$store.state.main.currency,
        };
        if (start === -1) {
          payload.coordinates_from = this.defaultZones.coordinates_from;
        }
        if (end === -1) {
          payload.coordinates_to = this.defaultZones.coordinates_from;
        }
        if (date !== 0) {
          // when changes the date on form
          this.rideSchedule = date;
        }
        if (this.rideSchedule != null) {
          // when changes only the zones, we check if date wasn't null
          payload.date_time = formatDateIsoLike(this.rideSchedule);
        }
        try {
          const { data } = await TransferAPI.getVehicles(payload);

          this.cars = data.sort((a, b) => parseFloat(a.total_price) - parseFloat(b.total_price));

          this.showImage = false;
          this.backToCars();
        } catch (error) {
          this.errors = errorResponse(error);

          this.showBookingData = false;
          this.showPayment = false;
          this.showCars = false;
        }
      } else {
        this.showCars = false;
      }
    },

    carSelected(car) {
      // show booking data
      this.showCars = false;
      this.selectedCar = car;
      this.bookingDataNeeded = 'DateAndPax';
      this.showBookingData = true;
    },
    async rideSelected(car) {
      // If is Ride Type, skips ask for addToCart data, send addToCart directly from here
      // & then redirects to check out data to ask for telephone. Continues then as usually to payment.
      this.showCars = false;
      this.selectedCar = car;

      this.bookErrors = {};
      try {
        const payload = {
          city_id: this.city.bd_city_id,
          zone_from: this.origin,
          zone_to: this.destination,
          vehicle_id: this.selectedCar.product.id,
          currency: this.selectedCar.currency,
        };

        if (this.rideSchedule) {
          payload.date_time = formatDateIsoLike(this.rideSchedule);
        }
        if (this.storeId) {
          payload.store_id = this.storeId;
        }
        if (this.origin === -1) {
          payload.coordinates_from = this.defaultZones.coordinates_from;
        }
        if (this.destination === -1) {
          payload.coordinates_to = this.defaultZones.coordinates_from;
        }

        const { data } = await TransferAPI.addToCart(payload);

        this.transfer = data.transfer;
        this.user = data.user;

        this.showBookingData = true;
        this.bookingDataNeeded = 'CheckoutData';
      } catch (error) {
        this.bookErrors = errorResponse(error);
      }
    },

    async addToCart(date, pax) {
      this.bookErrors = {};
      try {
        const payload = {
          city_id: this.city.bd_city_id,
          zone_from: this.origin,
          zone_to: this.destination,
          vehicle_id: this.selectedCar.id,
          pax,
          date_time: date,
          currency: this.selectedCar.currency,
          cutoff: this.selectedCar.cancellation,
        };

        if (this.storeId) {
          payload.store_id = this.storeId;
        }
        const { data } = await TransferAPI.addToCart(payload);

        this.transfer = data.transfer;
        this.requiredDataForCheckout = data.required_data_for_checkout;
        this.user = data.user;
        this.bookingDataNeeded = 'CheckoutData';
      } catch (error) {
        this.bookErrors = errorResponse(error);
      }
    },

    backToCars() {
      this.showBookingData = false;
      this.showPayment = false;
      this.showCars = true;
    },

    async sendCheckoutData(payload) {
      try {
        const { data } = await TransferAPI.checkout(this.transfer.id, payload);

        this.showBookingData = false;
        this.bookingDataNeeded = null;
        this.showPayment = true;

        this.returnUrl = `${process.env.VUE_APP_URL}/process_payment/stripe?transfer_id=${this.transfer.id}`;
        this.paymentData = data;
      } catch (error) {
        this.errors = errorResponse(error);
      }
    },

  },
};
</script>

<style scoped>
.alert-success{
  padding: .5rem .75rem ;
  font-weight: normal;
  line-height: 1.4;
}
</style>
